import { ValidationStates } from '@opengov/component-library/dist/Input/enums/ValidationStates';

import { Report } from '../../report/records/Report';

import { ReportTypes } from './reportTypes';

export const ReportFormRecordBase = {
  formState: ValidationStates.None,
  titleState: ValidationStates.None,
  typeState: ReportTypes.ChartAndDetails
};

export const EditableReport = Report({ title: '', description: '', parentFolderId: null });
